import { createSlice } from "@reduxjs/toolkit";

// ---- import from local actions ----
import { fetchUserPermissions, getPrivacyPolicy, getCopyRight } from "./../actions/AccessActions";


const AccessSlice = createSlice({
    name: "access",
    initialState: {
        userPermissions: [],
        privacyPolicy: {},
        copyright: {},

        // 用於處理異步請求的狀態
        fetchUserPermissions: {
            status: 'idle',
            error: "",
            loading: false,
        },
        getPrivacyPolicy: {
            status: 'idle',
            error: "",
            loading: false,
        },
        getCopyRight: {
            status: 'idle',
            error: "",
            loading: false,
        },
    },
    
    extraReducers: (builder) => {
      builder
        .addCase(fetchUserPermissions.pending, (state) => {
          state.fetchUserPermissions.loading = true;
        })
        .addCase(fetchUserPermissions.fulfilled, (state, action) => {
            state.fetchUserPermissions.loading = false;
            state.userPermissions = action.payload.result;
        })
        .addCase(fetchUserPermissions.rejected, (state, action) => {
          state.fetchUserPermissions.loading = false;
          state.fetchUserPermissions.error = action.error.message;
        })

        .addCase(getPrivacyPolicy.pending, (state) => {
          state.getPrivacyPolicy.loading = true;
        })
        .addCase(getPrivacyPolicy.fulfilled, (state, action) => {
            state.getPrivacyPolicy.loading = false;
            state.privacyPolicy = action.payload.result;
        })
        .addCase(getPrivacyPolicy.rejected, (state, action) => {
          state.getPrivacyPolicy.loading = false;
          state.getPrivacyPolicy.error = action.error.message;
        })

        .addCase(getCopyRight.pending, (state) => {
          state.getCopyRight.loading = true;
        })
        .addCase(getCopyRight.fulfilled, (state, action) => {
            state.getCopyRight.loading = false;
            state.copyright = action.payload.result;
        })
        .addCase(getCopyRight.rejected, (state, action) => {
          state.getCopyRight.loading = false;
          state.getCopyRight.error = action.error.message;
        })
    },
});


export default AccessSlice.reducer;
